// extracted by mini-css-extract-plugin
export default {"basicTag":"N50wumEwBn5qW3uvo6aP"};